import React from 'react';
import styled from 'styled-components';

import { Button, ButtonProps } from './button';

const StyledButton = styled(Button)`
  font-weight: 500;
  padding: 7px 16px;
  height: 40px;
  cursor: pointer;
  margin: 0;
`;

export function GhostButton({ children, ...props }: ButtonProps) {
  return (
    <StyledButton variant="ternary" {...props}>
      {children}
    </StyledButton>
  );
}
